import React, { useEffect, useRef } from 'react';
import { Row, Select } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import Form from 'antd/lib/form';
import { FormInstance } from 'antd/es/form';
import ParListSelect from 'components/ParListSelect';
import FormItem from 'antd/es/form/FormItem';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import { getFinContractById } from 'services/fincontract';
import { useQuery } from 'react-query';

export type TabTPProps = {
  objectid: number;
  form: FormInstance;
};

const TabUpdatePaymentMode = ({ form, objectid }: TabTPProps) => {

  const tprolecodeRef = useRef<string>();
  
  const { data: contract, isFetching } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data)
  );

  const onTPSelect = (e: any) => {
    console.log('e:::',e)
    const thirdparties= contract?.thirdParties.filter((tp)=>tp.tpid==e).map((th)=>{
        form.setFieldsValue({
            tpbkidin: th.tpbkidin,
            tpidclient: th.tpid,
            tppaymodein: th.tppaymodein,
            tppaydelayin: th.tppaydelayin,
            tpbkidout: th.tpbkidout,
            tppaymodeout: th.tppaymodeout,
            tppaydelayout: th.tppaydelayout,
            address: th.address,
            tprolecode: th.tprolecode
        });
        tprolecodeRef.current=th.tprolecode;
    });

  }

  useEffect(() => {
      form?.setFieldsValue({
        event: 'TabUpdatePaymentMode',
        tpadrid: form.getFieldValue('address'),
        tpbkidin: form.getFieldValue('tpbkidin'),
        tpidclient: form.getFieldValue('tpid'),
        tppaymodein: form.getFieldValue('tppaymodein'),
        tppaydelayin: form.getFieldValue('tppaydelayin'),
        tpbkidout: form.getFieldValue('tpbkidout'),
        tppaymodeout: form.getFieldValue('tppaymodeout'),
        tppaydelayout: form.getFieldValue('tppaydelayout'),
        tprolecode: tprolecodeRef.current
      });
    }, [form]);

  return (
    <DF.Provider pagcode="tabupdatepaymentmode">
      <Form form={form} layout="horizontal" labelCol={{ span: 24 }}>
        <Row gutter={16}>
          <FormInput comcode="tpid" name="tpid" col xs={6} shouldUpdate>
            <Select
              onSelect={(e) => {
                onTPSelect(e);
              }}
            >
              {contract?.thirdParties?.map((tp: any, index:number) => {
                return (
                  <Select.Option value={tp.tpid} key={index}>
                    {tp.tpreference +
                      ' - ' +
                      tp.tpname +
                      ' - ' +
                      tp.status}
                  </Select.Option>
                );
              })}
              {/* <ThirdPartyInput role={newRole} /> */}
            </Select>
          </FormInput>
        </Row>
        <Row gutter={16}>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput comcode="tpbkidin" name="tpbkidin" col xs={6}>
                <BankAccountListSelect
                  params={{
                    tpid: getFieldValue('tpidclient'),
                  }}
                />
              </FormInput>
            )}
          </FormItem>
          <FormInput
            comcode="tppaymodein"
            name="tppaymodein"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYMODEIN" />
          </FormInput>

          <FormInput
            comcode="tppaydelayin"
            name="tppaydelayin"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYDELAYIN" />
          </FormInput>

          {/* <FormInput name="tpmandatedate" col xs={6} shouldUpdate>
              <DatePicker />
            </FormInput> */}
        </Row>
        <Row gutter={16}>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                comcode="bankAccountOut"
                name="tpbkidout"
                col
                xs={6}
                shouldUpdate
              >
                <BankAccountListSelect
                  params={{
                    tpid: getFieldValue('tpidclient'),
                  }}
                />
              </FormInput>
            )}
          </FormItem>

          <FormInput
            comcode="tppaymodeout"
            name="tppaymodeout"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYMODEOUT" />
          </FormInput>
          <FormInput
            comcode="tppaydelayout"
            name="tppaydelayout"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYDELAYOU" />
          </FormInput>
        </Row>
        <Row gutter={16}>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                comcode="address"
                name="address"
                col
                xs={6}
                shouldUpdate
              >
                <AddresseListSelect
                  params={{
                    tpid: getFieldValue('tpidclient'),
                  }}
                />
              </FormInput>
            )}
          </FormItem>
        </Row>
      </Form>
    </DF.Provider>
  );
};
export default TabUpdatePaymentMode;
